module.exports = __webpack_public_path__ + "assets/date-range.21c0ab78.svg";